module.exports = __webpack_public_path__ + "static/homeEmailSample-f7c02889c00ef2e344a8c13b7c601f9c.png";